import {
  individualChatReset,
  setActiveChatUpdate,
  setChatMessage,
  setChatState,
  setSelectedAttachment,
  setTransferEndPoint,
  updateChatTranscript,

  updateLostMessage,
} from "../actions/chat";
import {
  API_CHAT_UPDATE,
  API_CONTACT_EVENT_LOGGING_CHAT,
  API_MILO_CHAT_CHANNEL_TRANSACTION,
  API_SEND_ATTACHMENT_DOWNLOAD_SAVEAS,
  STATE_WEBCHATMESSAGE,
} from "../constants/events";
import {
  getContactEventLoggingAPIHandler,
  getMiloDeeplink,
  getTransferEndpoints,
  updateContactReleaseToAIL,
} from "../api/session-api";
import { addChatToHistoryAction } from "../connector/history";
import {
  STATE_CHAT,
  STATE_CHAT_HISTORY,
  API_CHAT_TRANSFER_ENDPOINTS,
  SHOW_SELECTED_ATTACHMENT,
  API_CHECK_FOR_LOST_MESSAGE,
} from "../constants/constants";
import { INTERNAL_API_CHAT_HISTORY } from "../constants/events";
import Emitter from "../emitter";
import storeRTK from "../store/storeRTK";
import { SessionEvent } from "../types/call.type";
import { notificationManager } from "../utils/NotificationManager";
import { ChatMessage, IndividualChat } from "../types/chat.type";
import { setSelectedTab } from "../actions/common";
import { chatMsgRing, chatPlayer } from "../amazon-connect/handlers/chat";
import { downloadChatAttachment } from "../amazon-connect/api/chat";
import { setCurrentSessionTab } from "../actions/session";

function updateChat(event: SessionEvent<any>) {
  if (event.body?.self?.state === "RELEASED") {
    const state = storeRTK.getState();
    const ifChatPresent = state.chat.chats.findIndex(
      (chat: { id: string }) => chat.id === event.body?.id
    );

    if (ifChatPresent > -1) {
      // Add chat in history only if chat is present in state, because if not present it is already released
      storeRTK.dispatch(addChatToHistoryAction(event.body));
    }
    // check if there is another ringing chat except the current one, if yes dont pause the ringer
    const ifRingingChatPresent = state.chat.chats.filter(
      (chat: { self: { state: string }; id: string }) =>
        chat.self?.state === "RINGING" && chat.id !== event.body?.id
    );
    //to pause the ring only once, as the release event can come multiple
    // times and it can pause ringing of other chats.
    // if chat is present and there is no ringing chat
    if (ifChatPresent > -1 && ifRingingChatPresent.length === 0) {
      chatPlayer.pause();
      notificationManager.stopFaviconBlinking();
    }
    const wasActive = event.body.id === state.chat.activeChatID;
    let getActiveChatIndex = null;
    if (wasActive) {
      getActiveChatIndex = state.chat.chats.findIndex(
        (chat: { id: IndividualChat }) => chat.id === state.chat.activeChatID
      );
    }

    storeRTK.dispatch(individualChatReset(event.body));

    if (wasActive) {
      const newState = storeRTK.getState();
      const len = newState.chat.chats.length;
      if (len === 0) {
        const body = { chatID: "" };
        storeRTK.dispatch(setActiveChatUpdate(body));
      } else if (getActiveChatIndex === 0) {
        //when removed chat is first one
        const body = { chatID: newState.chat.chats[0].id };
        storeRTK.dispatch(setActiveChatUpdate(body));
      } else if (getActiveChatIndex === len) {
        //when removed chat was last one
        const body = { chatID: newState.chat.chats[len - 1].id };
        storeRTK.dispatch(setActiveChatUpdate(body));
      } else {
        //when removed chat was in middle
        const body = {
          chatID: newState.chat.chats[getActiveChatIndex - 1].id,
        };
        storeRTK.dispatch(setActiveChatUpdate(body));
      }
    }
    const chatConcurrency = state?.chat?.chats?.length;
    updateContactReleaseToAIL(
      "chat",
      event.body?.id as string,
      "",
      chatConcurrency || 0
    );
  } else if (event.body?.self?.state === "TERMINATED") {
    //Do nothing
  } else if (event.body) {
    const existingChatIndex = storeRTK
      .getState()
      .chat.chats.findIndex(
        (chat: { id: string }) => chat.id === event.body?.id
      );

    const state = storeRTK.getState();

    let chatSelfState = null;
    if (existingChatIndex !== -1) {
      // chat exists
      chatSelfState = state.chat?.chats[existingChatIndex]?.self?.state;
    }
    storeRTK.dispatch(setChatState(event.body));
    const newState = storeRTK.getState();
    if (
      newState.chat.chats.length === 1 &&
      newState.chat.chats[0].id !== newState.chat.activeChatID
    ) {
      const body = { chatID: newState.chat.chats[0].id };
      storeRTK.dispatch(setActiveChatUpdate(body));
    }
    // call chat transcript here.
    if (event.body?.self?.state === "ESTABLISHED") {
      if (event && event.body && event.body.id) {
        Emitter.emit(INTERNAL_API_CHAT_HISTORY, {
          body: {
            conversationId: event.body.id,
          },
        });
      }

      setTransferEndpoints(event.body?.id);
    }
    if (existingChatIndex === -1) {
      if (event.body?.self?.state == "RINGING") {
        storeRTK.dispatch(setCurrentSessionTab({ id: "chat" }));
        getContactEventLoggingAPIHandler(event?.body?.id ?? "", "RINGING");
        //handle chrome notification here
        notificationManager.playRingtone(chatPlayer);

        storeRTK.dispatch(setSelectedTab("Chats"));
        notificationManager.startFaviconBlinking();

        notificationManager.show("You have an incoming chat", {
          body: "Click or open iHub to answer it",
          icon: "icon.png",
          onclick: () => {
            Emitter.emit(API_CHAT_UPDATE, {
              body: {
                participantId: event.body?.id,
                conversationId: event.body?.id,
                state: "connected",
              },
            });
          },
        });
      } else {
        chatPlayer.pause();
        notificationManager.stopFaviconBlinking();
      }
    } else {
      if (event.body.self?.state != "RINGING") {
        if (chatSelfState != "ESTABLISHED") {
          chatPlayer.pause();
          notificationManager.stopFaviconBlinking();
        }
      }
    }
  }
}
/**
 * send notification to background
 * @param {*} messageEnvelope
 */
function updateChatMessage(messageEnvelope: { body: ChatMessage }) {
  console.log("incoming message event :", messageEnvelope);
  if (messageEnvelope.body) {
    if (messageEnvelope.body?.text) {
      if (messageEnvelope.body.role === "CUSTOMER") {
        notificationManager.playRingtone(chatMsgRing);
      }
      storeRTK.dispatch(setChatMessage(messageEnvelope.body));
    }
  }
}

export function updatetranscript(event: SessionEvent<any>) {
  if (event.body) {
    storeRTK.dispatch(updateChatTranscript(event.body));
  }
}

function showselectedAttachment(event: SessionEvent<any>) {
  storeRTK.dispatch(setSelectedAttachment(event?.body));
}


export async function setTransferEndpoints(contactId: string | undefined) {
  if (contactId) {
    const allowedTransferEndpoints = await getTransferEndpoints(contactId);
    storeRTK.dispatch(
      setTransferEndPoint({
        allowedTransferEndpoints,
        conversationId: contactId,
      })
    );
    Emitter.emit(API_CHAT_TRANSFER_ENDPOINTS, {
      body: {
        transferEndpoints: allowedTransferEndpoints,
        conversationId: contactId,
      },
    });
  } else {
    console.log("Error: error in setting transfer endpoints");
  }
}

export async function miloHandlerForChat(ev: SessionEvent<any>) {

  const miloDeeplink = await getMiloDeeplink("chat", ev.body?.contactId);
  if (miloDeeplink) {
    // put timeout because milo can come immediately and state may not be updated till then.
    setTimeout(() => {
      window.open(miloDeeplink, "_blank");
    }, 100);
  }
}

async function miloHandlerEventForChat(ev: SessionEvent<any>) {
  const miloEvent = {
    body: {
      contactId: ev.body?.contactId,
    },
  };
  notificationManager.triggerMilo(miloEvent, "chat");
}

// async function loggingHandlerEventForChat(ev: SessionEvent<any>) {
//   const loggingEvent = {
//     body: {
//       contactId: ev.body?.contactId,
//       eventType: ev.body?.eventType,
//     },
//   };
//   notificationManager.eventLoggingAPI(loggingEvent, "chat");
// }

export function checkLostMessage(event: SessionEvent<any>) {
  if (event.body) {
    storeRTK.dispatch(updateLostMessage(event.body));
  }
}

/**
 * Register default Events for chat
 */
export default function registerChatHandlerEvents() {
  Emitter.on(STATE_CHAT, updateChat);
  Emitter.on(STATE_WEBCHATMESSAGE, updateChatMessage);
  Emitter.on(API_MILO_CHAT_CHANNEL_TRANSACTION, miloHandlerEventForChat);
  // Emitter.on(API_CHECK_FOR_LOST_MESSAGE,checkLostMessage);
  // Emitter.on(API_CONTACT_EVENT_LOGGING_CHAT, loggingHandlerEventForChat);
  // Emitter.on(API_ACTIVE_CHAT_UPDATE, setActiveChat);
  Emitter.on(STATE_CHAT_HISTORY, updatetranscript);
  Emitter.on(API_CHECK_FOR_LOST_MESSAGE, checkLostMessage);
  Emitter.on(SHOW_SELECTED_ATTACHMENT, showselectedAttachment);
  // Emitter.on(SHOW_UPLOADING_ATTACHMENT,showuploadingAttachment);
  // Emitter.on(API_DOWNLOAD_ATTACHMENT, downloadAttachmentFromAmzn);

  // Download File
  Emitter.on(API_SEND_ATTACHMENT_DOWNLOAD_SAVEAS, downloadChatAttachment);
}
